"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobileEventType = void 0;
var MobileEventType;
(function (MobileEventType) {
    MobileEventType["USER_CREATED"] = "USER_CREATED";
    MobileEventType["USER_UPDATED"] = "USER_UPDATED";
    MobileEventType["TOKEN_TRANSFER"] = "TOKEN_TRANSFER";
    MobileEventType["BATCH_TRANSFER"] = "BATCH_TRANSFER";
    MobileEventType["CONSECUTIVE_TRANSFER"] = "CONSECUTIVE_TRANSFER";
    MobileEventType["PURCHASE"] = "PURCHASE";
    MobileEventType["PURCHASE_RANDOM"] = "PURCHASE_RANDOM";
    MobileEventType["LOOT_UNPACK"] = "LOOT_UNPACK";
    MobileEventType["LOOT_PURCHASE"] = "LOOT_PURCHASE";
    MobileEventType["MYSTERY_UNPACK"] = "MYSTERY_UNPACK";
    MobileEventType["MYSTERY_PURCHASE"] = "MYSTERY_PURCHASE";
    MobileEventType["LOTTERY_PURCHASE"] = "LOTTERY_PURCHASE";
    MobileEventType["LOTTERY_PRIZE"] = "LOTTERY_PRIZE";
    MobileEventType["LOTTERY_FINALIZE"] = "LOTTERY_FINALIZE";
    MobileEventType["LOTTERY_ROUND_START"] = "LOTTERY_ROUND_START";
    MobileEventType["LOTTERY_ROUND_END"] = "LOTTERY_ROUND_END";
    MobileEventType["RAFFLE_PURCHASE"] = "RAFFLE_PURCHASE";
    MobileEventType["RAFFLE_PRIZE"] = "RAFFLE_PRIZE";
    MobileEventType["RAFFLE_FINALIZE"] = "RAFFLE_FINALIZE";
    MobileEventType["RAFFLE_ROUND_START"] = "RAFFLE_ROUND_START";
    MobileEventType["RAFFLE_ROUND_END"] = "RAFFLE_ROUND_END";
    MobileEventType["STAKING_DEPOSIT_START"] = "STAKING_DEPOSIT_START";
    MobileEventType["STAKING_DEPOSIT_FINISH"] = "STAKING_DEPOSIT_FINISH";
    MobileEventType["STAKING_RULE_CREATED"] = "STAKING_RULE_CREATED";
    MobileEventType["STAKING_RULE_UPDATED"] = "STAKING_RULE_UPDATED";
    MobileEventType["STAKING_BALANCE_CHECK"] = "STAKING_BALANCE_CHECK";
    MobileEventType["WAITLIST_REWARD_SET"] = "WAITLIST_REWARD_SET";
    MobileEventType["WAITLIST_REWARD_CLAIMED"] = "WAITLIST_REWARD_CLAIMED";
    MobileEventType["CRAFT"] = "CRAFT";
    MobileEventType["DISMANTLE"] = "DISMANTLE";
    MobileEventType["MERGE"] = "MERGE";
    MobileEventType["CLAIM"] = "CLAIM";
    MobileEventType["RENT"] = "RENT";
    MobileEventType["RENT_USER"] = "RENT_USER";
    MobileEventType["LEVEL_UP"] = "LEVEL_UP";
    MobileEventType["VESTING_RELEASED"] = "VESTING_RELEASED";
    MobileEventType["BREED"] = "BREED";
    MobileEventType["REFERRAL"] = "REFERRAL";
})(MobileEventType || (exports.MobileEventType = MobileEventType = {}));
//# sourceMappingURL=mobile.js.map